import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import modelClassRequire from "@kaspernj/api-maker/build/model-class-require.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "preview": {
      "column": {
        "default": "0",
        "name": "preview",
        "null": false,
        "type": "boolean"
      },
      "name": "preview",
      "selected_by_default": null,
      "translated": null
    },
    "school_class_check_in_id": {
      "column": {
        "default": null,
        "name": "school_class_check_in_id",
        "null": true,
        "type": null
      },
      "name": "school_class_check_in_id",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": "new",
        "name": "state",
        "null": false,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    },
    "survey_id": {
      "column": {
        "default": null,
        "name": "survey_id",
        "null": false,
        "type": null
      },
      "name": "survey_id",
      "selected_by_default": null,
      "translated": null
    },
    "team_id": {
      "column": {
        "default": null,
        "name": "team_id",
        "null": false,
        "type": null
      },
      "name": "team_id",
      "selected_by_default": null,
      "translated": null
    },
    "translated_state": {
      "column": null,
      "name": "translated_state",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "TeamSurvey",
  "collectionKey": "team_surveys",
  "collectionName": "team_surveys",
  "i18nKey": "team_survey",
  "camelizedLower": "teamSurvey",
  "name": "TeamSurvey",
  "nameDasherized": "team-survey",
  "pluralName": "team_surveys",
  "ransackable_associations": [
    {
      "className": "TeamSurveyStepElementAnswer",
      "collectionName": "team_survey_step_element_answers",
      "foreignKey": "team_survey_step_element_id",
      "name": "answers",
      "macro": "has_many",
      "resource_name": "TeamSurveyStepElementAnswer",
      "through": "team_survey_step_elements"
    },
    {
      "className": "TeamSurvey::Audit",
      "collectionName": "team_survey_audits",
      "foreignKey": "team_survey_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "TeamSurveyAudit",
      "through": null
    },
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "class_step_id",
      "name": "class_step",
      "macro": "has_one",
      "resource_name": "ClassStep",
      "through": "school_class"
    },
    {
      "className": "TeamSurvey::Audit",
      "collectionName": "team_survey_audits",
      "foreignKey": "team_survey_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "TeamSurveyAudit",
      "through": null
    },
    {
      "className": "School",
      "collectionName": "schools",
      "foreignKey": "contact_id",
      "name": "school",
      "macro": "has_one",
      "resource_name": "School",
      "through": "school_class"
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "school_class_id",
      "name": "school_class",
      "macro": "has_one",
      "resource_name": "SchoolClass",
      "through": "team"
    },
    {
      "className": "SchoolClassCheckIn",
      "collectionName": "school_class_check_ins",
      "foreignKey": "school_class_check_in_id",
      "name": "school_class_check_in",
      "macro": "belongs_to",
      "resource_name": "SchoolClassCheckIn",
      "through": null
    },
    {
      "className": "SchoolClassCourseModule",
      "collectionName": "school_class_course_modules",
      "foreignKey": "team_survey_id",
      "name": "school_class_course_module",
      "macro": "has_one",
      "resource_name": "SchoolClassCourseModule",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "belongs_to",
      "resource_name": "Survey",
      "through": null
    },
    {
      "className": "Team",
      "collectionName": "teams",
      "foreignKey": "team_id",
      "name": "team",
      "macro": "belongs_to",
      "resource_name": "Team",
      "through": null
    },
    {
      "className": "TeamSurveyStepElement",
      "collectionName": "team_survey_step_elements",
      "foreignKey": "team_survey_step_id",
      "name": "team_survey_step_elements",
      "macro": "has_many",
      "resource_name": "TeamSurveyStepElement",
      "through": "team_survey_steps"
    },
    {
      "className": "TeamSurveyStep",
      "collectionName": "team_survey_steps",
      "foreignKey": "team_survey_id",
      "name": "team_survey_steps",
      "macro": "has_many",
      "resource_name": "TeamSurveyStep",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "legacy_school_class_brain_break_id",
      "column": {
        "default": null,
        "name": "legacy_school_class_brain_break_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "legacy_school_class_challenge_id",
      "column": {
        "default": null,
        "name": "legacy_school_class_challenge_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "preview",
      "column": {
        "default": "0",
        "name": "preview",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "school_class_check_in_id",
      "column": {
        "default": null,
        "name": "school_class_check_in_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "state",
      "column": {
        "default": "new",
        "name": "state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "survey_id",
      "column": {
        "default": null,
        "name": "survey_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "team_id",
      "column": {
        "default": null,
        "name": "team_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "SchoolClassCheckIn",
      "collectionName": "school_class_check_ins",
      "foreignKey": "school_class_check_in_id",
      "name": "school_class_check_in",
      "macro": "belongs_to",
      "resource_name": "SchoolClassCheckIn",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "belongs_to",
      "resource_name": "Survey",
      "through": null
    },
    {
      "className": "Team",
      "collectionName": "teams",
      "foreignKey": "team_id",
      "name": "team",
      "macro": "belongs_to",
      "resource_name": "Team",
      "through": null
    },
    {
      "className": "TeamSurveyStep",
      "collectionName": "team_survey_steps",
      "foreignKey": "team_survey_id",
      "name": "team_survey_steps",
      "macro": "has_many",
      "resource_name": "TeamSurveyStep",
      "through": null
    }
  ],
  "paramKey": "team_survey",
  "primaryKey": "id"
}

/** Frontend model for TeamSurvey. */
class TeamSurvey extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  preview() {
    return this.readAttributeUnderscore("preview")
  }

  /** @returns {boolean} */
  hasPreview() {
    const value = this.preview()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  schoolClassCheckInId() {
    return this.readAttributeUnderscore("school_class_check_in_id")
  }

  /** @returns {boolean} */
  hasSchoolClassCheckInId() {
    const value = this.schoolClassCheckInId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {any} */
  surveyId() {
    return this.readAttributeUnderscore("survey_id")
  }

  /** @returns {boolean} */
  hasSurveyId() {
    const value = this.surveyId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  teamId() {
    return this.readAttributeUnderscore("team_id")
  }

  /** @returns {boolean} */
  hasTeamId() {
    const value = this.teamId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedState() {
    return this.readAttributeUnderscore("translated_state")
  }

  /** @returns {boolean} */
  hasTranslatedState() {
    const value = this.translatedState()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static findOrCreateTeamSurveyStep(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callCollectionCommand(
      {
        args,
        command: "find_or_create_team_survey_step",
        collectionName: "team_surveys",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  currentStep(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "current_step",
        primaryKey: this.primaryKey(),
        collectionName: "team_surveys",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  submitAnswers(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "submit_answers",
        primaryKey: this.primaryKey(),
        collectionName: "team_surveys",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./school-class-check-in.js").default | null} */
  schoolClassCheckIn() {
    return this._readBelongsToReflection({reflectionName: "school_class_check_in"})
  }

  /** @returns {Promise<import("./school-class-check-in.js").default | null>} */
  loadSchoolClassCheckIn() {
    if (!("schoolClassCheckInId" in this)) throw new Error("Foreign key method wasn't defined: schoolClassCheckInId")

    const id = this.schoolClassCheckInId()
    const modelClass = modelClassRequire("SchoolClassCheckIn")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "school_class_check_in", model: this, modelClass},
      {ransack}
    )
  }

  /** @returns {import("./survey.js").default | null} */
  survey() {
    return this._readBelongsToReflection({reflectionName: "survey"})
  }

  /** @returns {Promise<import("./survey.js").default | null>} */
  loadSurvey() {
    if (!("surveyId" in this)) throw new Error("Foreign key method wasn't defined: surveyId")

    const id = this.surveyId()
    const modelClass = modelClassRequire("Survey")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "survey", model: this, modelClass},
      {ransack}
    )
  }

  /** @returns {import("./team.js").default | null} */
  team() {
    return this._readBelongsToReflection({reflectionName: "team"})
  }

  /** @returns {Promise<import("./team.js").default | null>} */
  loadTeam() {
    if (!("teamId" in this)) throw new Error("Foreign key method wasn't defined: teamId")

    const id = this.teamId()
    const modelClass = modelClassRequire("Team")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "team", model: this, modelClass},
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./team-survey-step.js").default>} */
  teamSurveySteps() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("TeamSurveyStep")

    const ransack = {}

    ransack["team_survey_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "team_survey_steps",
        model: this,
        modelName: "TeamSurveyStep",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./team-survey-step.js").default>>} */
  loadTeamSurveySteps() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("TeamSurveyStep")

    const ransack = {}

    ransack["team_survey_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "team_survey_steps",
        model: this,
        modelClass
      },
      {ransack}
    )
  }
}

export default TeamSurvey
